import React, { useState } from 'react';
import axios from '../../../constents/axios';
import styles from '../../../styles/createEvent.module.css';
import { FloatingLabel, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const ORACLE_STORAGE_URL = process.env.REACT_APP_ORACLE_STORAGE_URL;
const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

const CreateEvent = () => {
    const [color, setColor] = useState("#563d7c");
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        eventTitle: '',
        joinText: '',
        linkName: '',
        description: '',
        buttonText: '',
        buttonColor: color,
        desktopImage: null,
        phoneImage: null,
        eventDate: '',
        eventTime: '',
        eventFee: '',
    });

    const [isUploading, setIsUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handleFileChange = (e) => {
        const { id, files } = e.target;
        setFormData({ ...formData, [id]: files[0] });
    };

    const getFormattedDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Ensure two-digit month
        const day = String(today.getDate()).padStart(2, '0'); // Ensure two-digit day
        return `${year}-${month}-${day}`;
    };
    

    // Function to upload images to Oracle
    const uploadToOracle = async (file) => {
        if (!file) return null;

        setIsUploading(true);
        setProgress(0);

        const fileName = `${Date.now()}-${file.name}`;
        const todayDate = getFormattedDate(); // Get today's date in YYYY-MM-DD format
        const fileUrl = `${ORACLE_STORAGE_URL}Events/${todayDate}/${encodeURIComponent(fileName)}`;

        try {
            const response = await axios.put(fileUrl, file, {
                headers: {
                    "Content-Type": file.type,
                    Authorization: AUTH_TOKEN,
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    setProgress(percentCompleted);
                },
            });

            if (response.status === 200) {
                return fileUrl;
            } else {
                throw new Error("Failed to upload image to Oracle.");
            }
        } catch (error) {
            console.error("Oracle upload error:", error);
            return null;
        } finally {
            setIsUploading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Upload images to Oracle Storage first
        const desktopImageUrl = await uploadToOracle(formData.desktopImage);
        const phoneImageUrl = await uploadToOracle(formData.phoneImage);

        if (!desktopImageUrl || !phoneImageUrl) {
            alert("Failed to upload images. Please try again.");
            return;
        }
        const updatedDesktopUrl = desktopImageUrl.replace(
            "/p/jIul8gp04uV3Vwlb3zpEhXkRU1NVb8KdpdLMRya9OzTvgDs85JfcSd_kezfBr4IA",
            ""
          );
          const updatedPhoneUrl = phoneImageUrl.replace(
            "/p/jIul8gp04uV3Vwlb3zpEhXkRU1NVb8KdpdLMRya9OzTvgDs85JfcSd_kezfBr4IA",
            ""
          );
        
        

        // Prepare payload
        const eventPayload = {
            ...formData,
            desktopImage: updatedDesktopUrl,
            phoneImage: updatedPhoneUrl,
        };

        try {
            const response = await axios.post('/events/createEvent', eventPayload, {
                headers: { 'Content-Type': 'application/json' },
            });
            alert('Event Created Successfully!');
            navigate('/events');
            console.log(response.data);
        } catch (error) {
            console.error('Error creating event:', error);
            alert('Failed to create event');
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1>Create Event</h1>
            </div>

            <Form className="mt-4" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <FloatingLabel controlId="eventTitle" label="Title" className="mb-2">
                            <Form.Control type="text" placeholder="Enter event title" required onChange={handleChange} />
                        </FloatingLabel>

                        <FloatingLabel controlId="joinText" label="Join Text" className="mb-2">
                            <Form.Control type="text" placeholder="Enter join text" required onChange={handleChange} />
                        </FloatingLabel>

                        <FloatingLabel controlId="linkName" label="Link Name" className="mb-2">
                            <Form.Control type="text" placeholder="Enter link name" required onChange={handleChange} />
                        </FloatingLabel>

                        <Form.Group controlId="desktopImage" className="mb-3">
                            <Form.Label>Desktop Image</Form.Label>
                            <Form.Control type="file" accept="image/*" required onChange={handleFileChange} />
                        </Form.Group>

                        <FloatingLabel controlId="eventFee" label="Event Fee" className="mb-2">
                            <Form.Control type="number" placeholder="Enter event fee" required onChange={handleChange} />
                        </FloatingLabel>

                    </div>

                    <div className="col-md-6">
                        <FloatingLabel controlId="description" label="Description" className="mb-2">
                            <Form.Control as="textarea" placeholder="Enter detailed description" style={{ height: '130px' }} required onChange={handleChange} />
                        </FloatingLabel>

                        <FloatingLabel controlId="buttonText" label="Button Text" className="mb-2">
                            <Form.Control type="text" placeholder="Enter button text" required onChange={handleChange} />
                        </FloatingLabel>
                        <Form.Group controlId="phoneImage" className="mb-3">
                            <Form.Label>Phone Image</Form.Label>
                            <Form.Control type="file" accept="image/*" required onChange={handleFileChange} />
                        </Form.Group>
                        <div className='row'>
                        <div className="col-md-3">
                        <Form.Label htmlFor="buttonColor">Button Color</Form.Label>
                        <div className="d-flex align-items-center">
                            <Form.Control
                                type="color"
                                id="buttonColor"
                                value={color}
                                onChange={(e) => {
                                    setColor(e.target.value);
                                    setFormData({ ...formData, buttonColor: e.target.value });
                                }}
                                required
                                title="Choose your color"
                                style={{ width: '50px', height: '40px', cursor: 'pointer' }}
                            />
                            <Form.Control
                                type="text"
                                value={color}
                                onChange={(e) => setColor(e.target.value)}
                                className="ms-2 text-center"
                                style={{ width: '90px', fontWeight: 'bold', background: 'transparent', border: 'none' }}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                    <Form.Group controlId="eventDate" className="mb-3">
                            <Form.Label>Event Date</Form.Label>
                            <Form.Control type="date" required onChange={handleChange} />
                        </Form.Group>
                    </div>
                    <div className="col-md-4">
                    <Form.Group controlId="eventTime" className="mb-3">
                            <Form.Label>Event Time</Form.Label>
                            <Form.Control type="time" required onChange={handleChange} />
                        </Form.Group>
                    </div>
                        </div>
                    </div>
                </div>

                <div className="text-center mt-4">
                    <Button variant="primary" type="submit" disabled={isUploading}>
                        {isUploading ? `Uploading... ${progress}%` : "Create Event"}
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default CreateEvent;
